import { useState } from 'react'

import { customPost } from '../utils/customFetch.ts'

import { makeUrlSalenoteReassign } from './connectionData.tsx'

export interface SalenoteReassignInput {
  _id: string
  // Profile ids. Vacío = no se cambia
  seller?: string
  approver?: string
  cause: string
  by: string
}

const useSalenoteReassign = () => {
  const [errorSalenoteReassign, setErrorSalenoteReassign] = useState<Error | null>(null)
  const [loading, setLoading] = useState<boolean>(false)

  const salenoteReassign = async (input: SalenoteReassignInput) => {
    setLoading(true)

    try {
      const res = await customPost<{ message: string }>(makeUrlSalenoteReassign(), input)
      setErrorSalenoteReassign(null)

      return res
    } catch (err) {
      setErrorSalenoteReassign(err instanceof Error ? err : new Error('An unknown error occurred'))

      return null
    } finally {
      setLoading(false)
    }
  }

  return { errorSalenoteReassign, loading, salenoteReassign }
}
export default useSalenoteReassign
